import webApi from './webApi'
import { ApiClient } from './ApiClient'
import { IIncidentsData } from '../types'

const GetIncidents = async (
  apiClient: ApiClient,
  page: number,
  storeCode: string
): Promise<IIncidentsData> => {
  const response = await webApi.get<IIncidentsData>(apiClient, {
    url: `/api/incidents`,
    params: { pageNumber: page, storeCode: storeCode }
  })
  return response
}

const incidentsApi = {
  GetIncidents
}

export default incidentsApi
